import { render, staticRenderFns } from "./LeadActionCreation.vue?vue&type=template&id=1040ffc9"
import script from "./LeadActionCreation.vue?vue&type=script&lang=js"
export * from "./LeadActionCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports